import React, { useState } from 'react'
import { Paper, Group, Badge, Button } from '@mantine/core'
import ItemName from '../../../common/item-name'
import { EntityProfileParams } from 'app/models/entity-profile-params'
import { useDispatch } from 'react-redux'
import { removeEntityProfiles } from 'app/state/ducks/entity-profile/thunks'
import { ErrorNotification, SuccessNotification } from 'app/views/components/notifications/notification'
import DeleteConfirmation from 'app/views/components/delete-confirmation/DeleteConfirmation'

interface EntityItemProps {
    entity: EntityProfileParams
    isExpanded: boolean
    onEdit: (item: EntityProfileParams) => void
}

const EntityItem: React.FC<EntityItemProps> = ({
    entity,
    isExpanded,
    onEdit,
}) => {
    const dispatch = useDispatch()

    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false) // State to show delete modal

    const handleDeleteEntity = async (entityId: string) => {
        const result: any = await dispatch(removeEntityProfiles(entityId))
        if (!result.success) {
            ErrorNotification({ message: result.payload, title: 'Delete Entity Profile Failed' })
            return
        }
        SuccessNotification({
            message: 'The entity profile has been successfully deleted.',
            title: 'Delete Successful',
        })
    }

    const confirmDelete = () => {
        handleDeleteEntity(entity.id ?? '')
        setShowDeleteModal(false)
    }

    return (
        <>
            <Paper
                p="md"
                radius="md"
                className={`paper ${isExpanded ? 'paper-expanded' : ''}`}
            >
                <Group position="apart">
                    <Group spacing="sm">
                        <Badge className={`status-badge ${entity.isActive ? 'active' : 'inactive'}`}>
                            {entity.isActive ? 'ACTIVE' : 'INACTIVE'}
                        </Badge>
                        <ItemName name={entity.name} />
                    </Group>
                    <Group spacing="xs">
                        <Group spacing="xs">
                            <Button onClick={() => onEdit(entity)} className="edit-button">
                                Edit
                            </Button>
                            <Button
                                onClick={() => setShowDeleteModal(true)} // Show confirmation modal
                                className="delete-button delete-button-pink"
                            >
                                Delete
                            </Button>
                        </Group>
                    </Group>
                </Group>
            </Paper>

            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <DeleteConfirmation
                    onConfirm={confirmDelete} // Delete when confirmed
                    onCancel={() => setShowDeleteModal(false)} // Close modal on cancel
                    message="Delete This Entity Profile?" // Custom message
                />
            )}
        </>
    )
}

export default EntityItem
